import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import BerryExtensionHubModalComponent from '../components/berry-extension-hub-modal/berry-extension-hub-modal.jsx';
import {closeBerryExtensionHubModal} from '../reducers/modals';

class BerryExtensionHubModal extends React.Component {
    constructor (props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
    }
    handleClose () {
        this.props.onCloseBerryExtensionHubModal();
    }
    render () {
        if (!this.props.visible) return null;
        return (
            <BerryExtensionHubModalComponent
                onRequestClose={this.handleClose}
            />
        );
    }
}

BerryExtensionHubModal.propTypes = {
    visible: PropTypes.bool,
    onCloseBerryExtensionHubModal: PropTypes.func
};

const mapStateToProps = state => ({
    visible: state.scratchGui.modals.berryExtensionHubModal
});

const mapDispatchToProps = dispatch => ({
    onCloseBerryExtensionHubModal: () => dispatch(closeBerryExtensionHubModal())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BerryExtensionHubModal);